import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import {
  DefaultApiClient,
  DefaultApiResponse,
} from '@internal/backstage-plugin-devops-react';
import { CloudResourcesMenuApi } from './CloudResourcesMenuApi';

export class CloudResourcesMenuApiClient
  extends DefaultApiClient
  implements CloudResourcesMenuApi
{
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'catalog',
      ...options,
    });
  }

  async getAccountCloudResourcesMenu(
    accountId: string,
  ): Promise<DefaultApiResponse> {
    const urlSegment = `v2/account/${encodeURIComponent(
      accountId,
    )}/cloud-resources/menu`;
    return await this.get(urlSegment);
  }
}
